import { render, staticRenderFns } from "./PopDuzenle.vue?vue&type=template&id=4e875cf5&scoped=true&"
import script from "./PopDuzenle.vue?vue&type=script&lang=js&"
export * from "./PopDuzenle.vue?vue&type=script&lang=js&"
import style0 from "./PopDuzenle.vue?vue&type=style&index=0&id=4e875cf5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e875cf5",
  null
  
)

export default component.exports